import React, { Component } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addDays from "date-fns/addDays";

import { submitFormData } from "../utilities/formUtilities";
import { is_date } from "../utilities/dateUtlities";

class EventsModal extends Component {
  constructor(props) {
    let startDate = new Date();

    super(props);
    this.state = {
      hideModalFormClass: "show",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "hide",
      sponsorChecked: false,
      speakChecked: false,
      attendChecked: false,
      otherChecked: false,
      eventDate: addDays(startDate, 1),
      startDate: startDate,
      displayPurposeRequired: "hide",
      displayDateRequired: "hide",
      displayEventIndustryRequired: "hide",
    };
    this.submitForm = this.submitForm.bind(this);
    this.successfulSubmitForm = this.successfulSubmitForm.bind(this);
    this.resetAndHideModal = this.resetAndHideModal.bind(this);
    this.resetModal = this.resetModal.bind(this);
    this.errorSubmitForm = this.errorSubmitForm.bind(this);
    this.whatWouldbldAIdoChange = this.whatWouldbldAIdoChange.bind(this);
    this.sponsorCheckedHandle = this.sponsorCheckedHandle.bind(this);
    this.speakCheckedHandle = this.speakCheckedHandle.bind(this);
    this.attendCheckedHandle = this.attendCheckedHandle.bind(this);
    this.otherCheckedHandle = this.otherCheckedHandle.bind(this);
    this.handleEventDateChange = this.handleEventDateChange.bind(this);
    this.resetEventIndustryError = this.resetEventIndustryError.bind(this);
  }

  submitForm = (e) => {

    e.preventDefault();
    // console.log("submitting form");


    let formDataValid = true;

    let displayErrors = {};

    let eventIndustry = e.target.elements.eventIndustry.value;

    if (!(this.state.sponsorChecked || this.state.speakChecked || this.state.attendChecked || this.state.otherChecked)) {
      formDataValid = false;
      displayErrors["displayPurposeRequired"] = "show"; 
    }

    if (eventIndustry === "DEFAULT") {
      formDataValid = false;
      displayErrors["displayEventIndustryRequired"] = "show"; 
    }


    if (formDataValid) {

      let firstName = e.target.elements.firstName.value;
      let lastName = e.target.elements.lastName.value;
      let email = e.target.elements.email.value;
      let eventName = e.target.elements.eventName.value;
      let eventLocation = e.target.elements.eventLocation.value;
      let eventDate = this.state.eventDate;
      let numberOfAttendees = e.target.elements.numberOfAttendees.value;

      let eventPurposeArray = [];

      if (this.state.sponsorChecked) {
        eventPurposeArray.push("Sponsor/Exhibit");
      }

      if (this.state.speakChecked) {
        eventPurposeArray.push("Speak");
      }

      if (this.state.attendChecked) {
        eventPurposeArray.push("Attend");
      }

      if (this.state.otherChecked) {
        eventPurposeArray.push("Other");
      }

      let eventPurpose = eventPurposeArray.join(", ");


      let submitData = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        eventName: eventName,
        eventLocation: eventLocation,
        eventDate: eventDate,
        numberOfAttendees: numberOfAttendees,
        eventIndustry: eventIndustry,
        eventPurpose: eventPurpose,
      };

      // console.log(submitData);

      /*
      https://formcarry.com/s/_3y3dh9olpGV
      bld_ai_events_contact@bld.ai
      */

      submitFormData(
        "https://formcarry.com/s/_3y3dh9olpGV",
        submitData,
        this.successfulSubmitForm,
        this.errorSubmitForm,
        this.errorSubmitForm
      );
    } else {
      this.setState(displayErrors);
    }
  }

  successfulSubmitForm = () => {
    this.setState({ 
      hideModalFormClass: "hide",
      displaySuccessSubmitClass: "show",
      displayErrorSubmitClass: "hide",
    });
  }

  errorSubmitForm = () => {
    this.setState({ 
      hideModalFormClass: "hide",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "show",
    });
  }

  resetModal = () => {
    let eventsForm = document.getElementById("eventsForm");
    let startDate = new Date();

    eventsForm.reset();
    this.setState({ 
      hideModalFormClass: "show",
      displaySuccessSubmitClass: "hide",
      displayErrorSubmitClass: "hide",
      sponsorChecked: false,
      speakChecked: false,
      attendChecked: false,
      otherChecked: false,
      eventDate: addDays(startDate, 1),
      startDate: startDate,
      displayPurposeRequired: "hide",
      displayDateRequired: "hide",
      displayEventIndustryRequired: "hide",
    });
  }

  resetAndHideModal = () => {
    this.resetModal();
    this.props.closeModal();
  }

  whatWouldbldAIdoChange = (checkedKey) => {
    this.setState(prevState => ({
      [checkedKey]: !prevState[checkedKey],
      displayPurposeRequired: "hide", 
    }));
  }

  resetEventIndustryError= () => {
    this.setState({
      displayEventIndustryRequired: "hide", 
    });
  }

  sponsorCheckedHandle = () => {
    this.whatWouldbldAIdoChange("sponsorChecked");
  }

  speakCheckedHandle = () => {
    this.whatWouldbldAIdoChange("speakChecked");
  }

  attendCheckedHandle = () => {
    this.whatWouldbldAIdoChange("attendChecked");
  }

  otherCheckedHandle = () => {
    this.whatWouldbldAIdoChange("otherChecked");
  }

  handleEventDateChange = (date) => {
    console.log(date);

    let date_check = is_date(date);

    if (date_check) {
      this.setState({
        eventDate: date
      });
    }

  };

  render() {
    return(
      <Modal show={this.props.modalOpen} onHide={this.resetAndHideModal} centered>
        <Modal.Header className="header-center" closeButton>
          <span className="modal-header-text">
            Event Speaking and Sponsorhips
          </span>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <p className="text-center mb-5">Would you like bld.ai to sponsor or speak at your event? Fill out this form and a member of our team will be in touch with you shortly. </p>
            <section className={"contact contactFormContainer " + this.state.hideModalFormClass}>
              <form acceptCharset="UTF-8" className="contact-form ajax" onSubmit={this.submitForm} id="eventsForm">
                <Row>
                  <Col sm="12" md="6">
                    <Form.Group>
                      <Form.Label>First name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="firstName" />
                    </Form.Group>
                  </Col>
                  <Col sm="12" md="6">
                    <Form.Group>
                      <Form.Label>Last name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="lastName" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Email<span className="required">*</span></Form.Label>
                      <Form.Control required type="email" name="email" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Event Name<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="eventName" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Label>Event Location<span className="required">*</span></Form.Label>
                      <Form.Control required type="text" name="eventLocation" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" md="6">
                    <Form.Group className="eventDateLabel mb-3">
                      <Form.Label>Event Date<span className="required">*</span></Form.Label>
                      <br />
                      <DatePicker
                        className={"form-control"}
                        selected={this.state.eventDate}
                        onChange={this.handleEventDateChange}
                        excludeDates={[this.state.startDate]}
                        placeholderText="Select a date starting tomorrow"
                        minDate={addDays(this.state.startDate, 1)}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="12" md="6">
                    <Form.Group>
                      <Form.Label># of Attendees<span className="required">*</span></Form.Label>
                      <Form.Control required type="number" name="numberOfAttendees" />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Label>Event Industry<span className="required">*</span></Form.Label>
                  </Col>
                </Row>
                <Row className={"eventIndustryRequired " + this.state.displayEventIndustryRequired}>
                  <Col sm="12">
                    <p>Please select one of the event industries</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group>
                      <Form.Control as="select" required name="eventIndustry" defaultValue={'DEFAULT'} onChange={this.resetEventIndustryError}>
                        <option value="DEFAULT" disabled>Please select</option>
                        <option value='Software/Tech'>Software/Tech</option>
                        <option value="Fintech">Fintech</option>
                        <option value="Automotive">Automotive</option>
                        <option value="QSR/Restaurants">QSR/Restaurants</option>
                        <option value="Healthcare">Healthcare</option>
                        <option value="Artificial Intelligence">Artificial Intelligence</option>
                        <option value="Other">Other</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Label>I would like bld.ai to<span className="required">*</span></Form.Label>
                  </Col>
                </Row>
                <Row className={"eventPurposeRequired " + this.state.displayPurposeRequired}>
                  <Col sm="12">
                    <p>Please check at least one of the checkboxes</p>
                  </Col>
                </Row>
                <Row key={"bldai_activities"}>
                  <Col sm="12" md="6">
                    <Form.Check
                      type={"checkbox"}
                      id={"sponsor_exhibit"}
                      label={"Sponsor/Exhibit"}
                      name={"sponsor_exhibit"}
                      onChange={this.sponsorCheckedHandle}
                      checked={this.state.sponsorChecked}
                    />
                    <Form.Check
                      type={"checkbox"}
                      id={"speak"}
                      label={"Speak"}
                      name={"speak"}
                      onChange={this.speakCheckedHandle}
                      checked={this.state.speakChecked}
                    />
                  </Col>
                  <Col sm="12" md="6">
                    <Form.Check
                      type={"checkbox"}
                      id={"attend"}
                      label={"Attend"}
                      name={"attend"}
                      onChange={this.attendCheckedHandle}
                      checked={this.state.attendChecked}
                    />
                    <Form.Check
                      type={"checkbox"}
                      id={"other"}
                      label={"Other"}
                      name={"other"}
                      onChange={this.otherCheckedHandle}
                      checked={this.state.otherChecked}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12" className="mt-3">
                    <input type="hidden" name="_gotcha" />
                    <Button className="btn-submit hs-button" type="submit">Submit</Button>
                    <Button className="hs-button ml-2 btn-secondary" onClick={this.resetAndHideModal}>Close</Button>
                  </Col>
                </Row>
              </form>
            </section>
            <section className={"contact contactFormContainer confirmationMessage " + this.state.displaySuccessSubmitClass}>
              <p>Form submitted successfully</p>
              <Button className="btn-submit hs-button" onClick={this.resetModal}>
                Send another event speaking and sponsorships query
              </Button>
            </section>
            <section className={"contact contactFormContainer confirmationMessage " + this.state.displayErrorSubmitClass}>
              <p>There was an error with the submission. Please try again</p>
              <Button className="btn-submit hs-button" onClick={this.resetModal}>
                Send another event speaking and sponsorships query
              </Button>
            </section>
          </Container>
        </Modal.Body>
      </Modal>
    );
  }
}

export default (EventsModal);